import React from 'react';
import { serviceCategories } from '../data/servicesData';
import { FaWhatsapp } from 'react-icons/fa';
import SocialShare from '../common/SocialShare';

const ServiceMenu = () => {
  return (
    <section id="services" className="py-20 px-4 bg-white relative">
      {/* Background Flag Decoration */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-mx-green via-white to-mx-red"></div>
      
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-serif font-black text-black mb-4">
            SERVICE MENU
          </h2>
          <p className="text-mx-gold text-xl font-serif italic mb-8">Menú de 111 Servicios</p>
          <div className="w-24 h-1 bg-black mx-auto"></div>
        </div>

        <div className="grid gap-12">
          {serviceCategories.map((category) => (
            <div key={category.id} className="bg-gray-50 rounded-3xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-shadow relative overflow-hidden">
              {/* Category Header */}
              <div className="flex items-center gap-4 mb-8 relative z-10">
                <div className="w-16 h-16 bg-mx-green/10 rounded-full flex items-center justify-center text-mx-green text-3xl">
                  <category.icon />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-black uppercase">{category.titleEn}</h3>
                  <p className="text-gray-500 italic font-serif">{category.titleEs}</p>
                </div>
              </div>

              {/* Service List */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10">
                {category.items.map((item, idx) => (
                  <div key={idx} className="bg-white p-6 rounded-xl border border-gray-100 hover:border-mx-gold transition-all group hover:-translate-y-1 flex flex-col h-full">
                    <div className="flex justify-between items-start mb-2">
                      <h4 className="font-bold text-lg text-gray-900 group-hover:text-mx-green transition-colors leading-tight">
                        {item.nameEn}
                      </h4>
                    </div>
                    <p className="text-sm text-gray-500 italic mb-3 border-b border-gray-100 pb-2">{item.nameEs}</p>
                    
                    <div className="flex justify-between items-center mb-4">
                      <div className="font-black text-mx-green text-xl">${item.priceMXN} <span className="text-xs text-gray-400 font-normal">MXN</span></div>
                      <div className="text-sm text-gray-500 font-bold">${item.priceUSD} <span className="text-xs font-normal">USD</span></div>
                    </div>
                    
                    <p className="text-xs text-gray-600 mb-4 h-10 overflow-hidden">
                      {item.descEn}
                    </p>
                    
                    <div className="mt-auto">
                      <a 
                        href={`https://wa.me/529841771113?text=I want to book / Quiero reservar: ${item.nameEn}`}
                        target="_blank"
                        rel="noreferrer"
                        className="w-full bg-black text-white py-3 rounded-lg text-xs font-bold uppercase hover:bg-mx-green transition-colors flex items-center justify-center gap-2 shadow-lg mb-4"
                      >
                        <FaWhatsapp className="text-lg" /> Book / Reservar
                      </a>
                      
                      {/* Social Share Component Added */}
                      <SocialShare 
                        title={`${item.nameEn} at Eyelashes Mexico`}
                        text={`Check out this service: ${item.descEn}`}
                        url="https://eyelashesmexico.com"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceMenu;